<template>
  <div>
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2 class="pl-2">
          {{ editRoute ? $t("labels.edit_folder") : $t("labels.add_folder") }}
        </h2>
      </div>
    </div>
    <div class="addedit-folder center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-folder-card">
          <div v-if="ga_plan_image && is_mapped">
            <h4>GA Plan Image:</h4>
            <div
              class="image-container mb-3"
              @mousemove="handleDragging($event)"
              @mouseup="stopDragging($event)"
            >
              <img
                ref="ga_plan_image"
                :src="ga_plan_image"
                alt="ga-plan-image"
                width="800"
                style="width: 1000px; height: 600px; object-fit: contain"
                @mousemove="handleDragging($event)"
                @mouseup="stopDragging($event)"
                @touchend="stopDragging($event)"
                @touchcancel="stopDragging($event)"
              />
              <div
                class="pin"
                :style="{
                  left: location.x + 'px',
                  top: location.y + 'px',
                }"
                @mousedown="startDragging($event)"
                @mouseup="stopDragging($event)"
                @touchend="stopDragging($event)"
                @touchcancel="stopDragging($event)"
              >
                <div
                  class="text-white"
                  :class="location.color == 'red' ? 'red-pin' : 'yellow-pin'"
                  draggable="true"
                ></div>
              </div>
            </div>
          </div>
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full md:w-1/2 pl-0 mb-4">
              <label>{{ $t("labels.folder_name") }}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="folder_name"
                maxlength="100"
                v-model="folder_name"
                icon-no-border
                :placeholder="$t('labels.folder_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{
                errors.first("folder_name")
              }}</span>
            </div>
            <div
              class="vx-col w-full md:w-1/2 pl-0 pr-0 mt-6 flex sm: justify-center md:justify-start align-items-center"
              v-if="ga_plan_image"
            >
              <label>Mapped Folder: {{ is_mapped }}</label>
              <vs-switch color="primary" v-model="is_mapped" class="ml-4">
                <span slot="on">Mapped</span>
                <span slot="off">Un-Mapped</span>
              </vs-switch>
            </div>
          </div>
          <div class="mt-2 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-folder"
              button="submit"
              >{{
                editRoute ? $t("labels.update_folder") : $t("labels.add_folder")
              }}</vs-button
            >
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      folder_name: null,
      is_mapped: false,
      location: null,
      isDragging: false,
      ga_plan_image: null,
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.sub_folder_id) {
        return this.$route.params.sub_folder_id;
      } else {
        return false;
      }
    },
    folder_id() {
      if (this.$route.params.folder_id) {
        return this.$route.params.folder_id;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.setValidationMessage();
    if (this.editRoute) {
      this.getSubFolder();
    } else {
      this.getFolder();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createUpdateSubFolder();
        }
      });
    },
    async createUpdateSubFolder() {
      if (this.is_mapped && this.location && this.location.color == "red") {
        this.$vs.notify({
          title: "Error.",
          text: "Please map the sub folder location",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      let input = {
        folder_id: this.folder_id,
        folder_name: this.folder_name,
      };
      input.location = this.is_mapped
        ? JSON.stringify({ x: this.location.x, y: this.location.y })
        : null;
      let url = this.editRoute
        ? `/folders/${this.folder_id}/subfolder/update/` + this.editRoute
        : `/folders/${this.folder_id}/subfolder/create`;
      let response = this.editRoute
        ? await this.getHTTPPutResponse(url, input, "#create-folder", true)
        : await this.getHTTPPostResponse(url, input, "#create-folder", true);
      if (response && response.status == 200) {
        if (response.data && response.data.subFolder.folder) {
          const vessel_type_id = response.data.subFolder.folder.vessel_type_id;
          const vessel_sub_type_id =
            response.data.subFolder.folder.vessel_sub_type_id;
          this.$router.push({
            name: "ListSubFolder",
            params: { id: this.folder_id },
            query: {
              vessel_type_id,
              vessel_sub_type_id,
            },
          });
        } else {
          this.$router.push({
            name: "ListSubFolder",
            params: { id: this.folder_id },
          });
        }
      }
    },
    async getFolder() {
      const folder_id = this.$route.params.folder_id;
      let response = await this.getHTTPGetResponse("/folders/get/" + folder_id);
      if (response) {
        let data = response.data;
        let folder = data.folder;
        if (folder.ga_plan_image) this.ga_plan_image = folder.ga_plan_image;
      }
    },
    async getSubFolder() {
      let response = await this.getHTTPGetResponse(
        `/folders/${this.folder_id}/subfolder/get/` + this.editRoute
      );
      if (response) {
        let data = response.data;
        let subFolder = data.subFolder;
        this.folder_name = subFolder.folder_name;
        this.ga_plan_image = subFolder.folder.ga_plan_image;
        this.location =
          this.ga_plan_image && subFolder.location
            ? JSON.parse(subFolder.location, true)
            : null;
        this.is_mapped = subFolder.location != null;
      }
    },
    goBack() {
      this.$router.push({
        name: "ListSubFolder",
        params: { id: this.folder_id },
      });
    },
    handleSwitch() {
      if (this.is_mapped) {
        let location = this.location;
        if (!location) {
          location = {
            x: 50,
            y: 50,
            color: "red",
          };
          this.location = location;
        }
      }
    },
    handleDragging(event) {
      if (this.isDragging) {
        const marker = this.location;
        marker.x = event.clientX - this.initialX;
        marker.y = event.clientY - this.initialY;
      }
    },
    startDragging(event) {
      event.preventDefault();
      this.isDragging = true;
      const marker = this.location;
      this.initialX = event.clientX - marker.x;
      this.initialY = event.clientY - marker.y;
    },
    stopDragging() {
      if (this.isDragging) {
        this.location.color = "yellow";
        this.isDragging = false;
      }
    },
  },
  watch: {
    is_mapped() {
      this.handleSwitch();
    },
  },
};
</script>
<style lang="scss" scoped>
.image-container {
  position: relative;
}

.yellow-pin::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 30px;
  height: 30px;
  background-color: #ec9a29;
  border-radius: 50% 50% 50% 0;
  z-index: -1;
}

.red-pin::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 30px;
  height: 30px;
  background-color: red;
  border-radius: 50% 50% 50% 0;
  z-index: -1;
}

.marker {
  position: absolute;
  background-color: red;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.pin {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  transition: transform 0.3s ease, filter 0.3s ease;
  cursor: grab;
}
</style>
